import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const useAdvertisementComponent = () => {
  const [advertisementColor, setAdvertisementColor] = useState<string>('#E0F2FE');

  const advertisement = useSelector((state: any) => state.interfaceApp.advertisement);

  useEffect(() => {
    if (!advertisement) {
      setAdvertisementColor('#E0F2FE'); // значение по умолчанию
      return;
    }
    switch (advertisement.type) {
      case 'info':
        setAdvertisementColor('#E0F2FE');
        return;
      case 'warning':
        setAdvertisementColor('#FEF3C7');
        return;
      default:
        return;
    }
  }, [advertisement]);

  return {
    advertisement,
    advertisementColor,
  };
};
